import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, CanLoad, Route, Router, CanActivateChild } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';
import { PersonRoleEnum } from '../Models/OtherClasses';

@Injectable()
export class EmployeeAuthGuard implements CanActivate, CanLoad {

	constructor(public configData: ConfigService, protected router: Router) { }

	canLoad(route: Route): boolean {
		var allowedRoles: string[] = [];
		if (route && route.data && route.data.allowedRoles) {
			allowedRoles = route.data.allowedRoles;
		}
		if (!allowedRoles.length) {
			return true;
		}
		for (var i = 0; i < allowedRoles.length; i++) {
			allowedRoles[i] = allowedRoles[i].toUpperCase();
		}
		return this.redirectIfNeeded(this.intersection(this.configData.allowedRoles, allowedRoles).length > 0
			|| this.configData.allowedRoles.filter(a => a == PersonRoleEnum.SUPERADMIN).length > 0);
	}

	
	
	canActivate(route: ActivatedRouteSnapshot): boolean {
		var allowedRoles: string[] = [];
		if (route && route.data && route.data.allowedRoles) {
			allowedRoles = route.data.allowedRoles;
		}
		if (!allowedRoles.length) {
			return true;
		}
		for (var i = 0; i < allowedRoles.length; i++) {
			allowedRoles[i] = allowedRoles[i].toUpperCase();
		}
		return this.redirectIfNeeded(this.intersection(this.configData.allowedRoles, allowedRoles).length > 0
			|| this.configData.allowedRoles.filter(a => a == PersonRoleEnum.SUPERADMIN).length > 0);
	}

	redirectIfNeeded(isOk: boolean) {
		if (isOk) {
			return true;
		} else {
			this.router.navigate(['ang/Payment/NoAccess']);
			return false;
		}
	}

	//http://benjaminzhang.com/blog/intersection-of-two-arrays-in-typescript/
	intersection(array1: string[], array2: string[]): string[] {
		let result: string[] = [];
		let dict: {[key: string]: any} = {};
		for (let el of array1) {
			if (!(el in dict)) {
				dict[el] = 1;
			}
		}

		for (let el2 of array2) {
			if (el2 in dict && dict[el2] !== 2) {
				dict[el2] = 2;
				result.push(el2);
			}
		}

		return result;
	};
}